import type { IFilter } from '@models/Filter'
import type { Page } from '@models/Page'
import type { Projectbetrokkene } from '@models/Projectbetrokkene'
import type { Sort } from '@models/Query'
import type { SearchResults } from '@models/SearchResults'

import { request } from '../../../gateways/api'
import type {
  ContractinstellingenSearch,
  ContractinstellingenSearchFilters,
} from '../types/ContractinstellingenSearch'

export { fetchProjectbetrokkenen, initialState }

const fetchProjectbetrokkenen = async (
  filters: Partial<ContractinstellingenSearchFilters>,
) => {
  const result = await request<SearchResults<Projectbetrokkene>>({
    url: '/rest/projectbetrokkene/search',
    method: 'POST',
    data: {
      filters: createFilters(filters),
      skip: 0,
      limit: 9999,
    },
  })

  return result
}

const initialState: {
  data: SearchResults<Projectbetrokkene>
  query: ContractinstellingenSearch['query'] & {
    page?: Page
    sort?: Sort | Record<string, any>
  }
} = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
  query: {
    filters: {
      verantwoordelijke: null,
    },
  },
}

const createFilters = ({
  verantwoordelijke,
}: Partial<ContractinstellingenSearchFilters>) => {
  const filters: IFilter[] = [
    { name: 'projectType', value: 'Hoofdleiding', operator: 'eq' },
  ]

  if (verantwoordelijke)
    filters.push({
      name: 'verantwoordelijke',
      value: verantwoordelijke.code,
      operator: 'eq',
    })

  return filters
}
